import React, { Fragment } from 'react';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { H3, H4, H6, P, Image, Btn } from '../../../AbstractElements';
import { MyProfile, Bio, Password, Website, Save, MarkJecno, Designer, ProfileBio, Address, Email } from '../../../Constant';

const MyProfileEdit = () => {
  return (
    <Fragment>
      <Card>
        <CardHeader className='pb-0'>
          <H4 className='card-title mb-0'>{MyProfile}</H4>
          <div className='card-options'>
            <a className='card-options-collapse' href='#javascript'>
              <i className='fe fe-chevron-up'></i>
            </a>
            <a className='card-options-remove' href='#javascript'>
              <i className='fe fe-x'></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Form>
            <Row className='mb-2'>
              <div className='profile-title'>
                <div className='d-flex'>
                  <Image className='img-70 rounded-circle' alt='' src={require('../../../assets/images/user/7.jpg')} />
                  <div className='flex-grow-1 ms-3'>
                    <H3 className='mb-1 f-20 txt-primary text-uppercase'>{MarkJecno}</H3>
                    <P className='text-uppercase f-12'>{Designer}</P>
                  </div>
                </div>
              </div>
            </Row>
            <FormGroup className='mb-3'>
              <H6 className='form-label'>{Bio}</H6>
              <Input type='textarea' className='form-control' rows='5' defaultValue={ProfileBio} />
            </FormGroup>
            <FormGroup className='mb-3'>
              <Label className='form-label'>
                {Email}-{Address}
              </Label>
              <Input className='form-control' placeholder='your-email@domain.com' />
            </FormGroup>
            <FormGroup className='mb-3'>
              <Label className='form-label'>{Password}</Label>
              <Input className='form-control' type='password' defaultValue='password' />
            </FormGroup>
            <FormGroup className='mb-3'>
              <Label className='form-label'>{Website}</Label>
              <Input className='form-control' placeholder='http://Uplor .com' />
            </FormGroup>
            <div className='form-footer'>
              <Btn className='btn-block' color='primary'>
                {Save}
              </Btn>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default MyProfileEdit;
